<div class="my-4">
  <app-placeholder icon="SecurityAndWarningsInfo" title="">
    <h3 i18n>Are you still here?</h3>
  </app-placeholder>

  <div class="modal-body text-center py-4">
    @let orgName = config()?.org?.name;
    <p i18n>
      For security, the
      @if (orgName) {
        <strong>{{ orgName }}</strong>
      }
      organization has set an inactivity dectection timeout.
    </p>
    <p i18n class="mt-4">Your session will timeout in</p>
    <p class="fw-bold fs-2">{{ countdown() }}</p>
    @if (isCookieExpiring()) {
      <ngb-alert class="alert alert-warning mt-3 text-start" [dismissible]="false" role="alert">
        <p i18n class="mb-0">
          <strong>Warning:</strong> Your session token is also expiring within 5 minutes. You will
          need to log in again.
        </p>
      </ngb-alert>
    } @else {
      <p i18n class="mt-4">
        Please confirm that you are still working to keep your session active.
      </p>
    }
  </div>

  <app-modal-footer class="d-flex justify-content-center">
    @if (isCookieExpiring()) {
      <button type="button" class="btn btn-primary" (click)="onConfirm(true)" i18n>
        Log in again
      </button>
    } @else {
      <button type="button" class="btn btn-primary" (click)="onConfirm()" i18n>
        Yes, I'm here
      </button>
    }
  </app-modal-footer>
</div>
